// extracted by mini-css-extract-plugin
export default {"icon":"TableControls_icon__sbGMv"};